import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const resend = defineConnector({
  identifier: "resend",
  name: "Resend",
  tagLine: "Email API for developers",
  keywords:
    "transactional smtp deliverability domains broadcasts audiences contacts",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://api\\.resend\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to the [Resend dashboard](https://resend.com/api-keys) and click **Create API Key**.\n\nGive it a name, select the appropriate permission level and domain, then click **Add**.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Paste the API key you just created. **Make sure to copy it now** — Resend only shows it once.",
        },
        {
          kind: "input",
          label: "API key",
          placeholder: "re_...",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.resend.com/domains",
  },
});
